import { AppStatus } from "./AppStatus";
import { Button } from "./ui/button";
import { resolveRetiredAppInfo } from "../config/retiredApp";

interface RetiredAppNoticeProps {
  hostName?: string;
}

export function RetiredAppNotice({ hostName }: RetiredAppNoticeProps) {
  const info = resolveRetiredAppInfo(hostName);

  return (
    <AppStatus
      title={`Trimble Assistant for ${info.hostName} has been retired and is no longer supported.`}
      detail={
        <>
          Please update to{" "}
          {info.minVersion
            ? `${info.hostName} ${info.minVersion} or newer`
            : `the latest version of ${info.hostName}`}{" "}
          to access the new Civil Design Assistant.
          {info.releaseNotesUrl && (
            <>
              {" "}
              <Button
                variant="link"
                render={
                  <a
                    href={info.releaseNotesUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                }
                nativeButton={false}
              >
                What's new
              </Button>
            </>
          )}
        </>
      }
    />
  );
}
